import { plainToInstance } from 'class-transformer'
import {
    GetDomainNotificationABTestResponse,
    GetNotificationResponse,
    GetNotificationScheduleResponse,
    GetNotificationTemplateChannelsResponse,
} from '@pushly/models/lib/structs/notifications'

// Re-export domain helpers for convenience
export {
    isTzDelivery,
    isTzDeliveryInProgress,
    canShowStats,
    isDelivered,
    isPartialFailure,
    isNotificationEditable,
    getLegacyAudienceType,
} from '@pushly/models/lib/utils/notification-helpers'

export function parseNotificationResponse(data: object): GetNotificationResponse {
    const result = plainToInstance(GetNotificationResponse, data, {
        excludeExtraneousValues: false,
    })

    if (Array.isArray(result.schedules) && result.schedules.length > 0) {
        const scheduleStatus = result.schedules[0].status
        if (scheduleStatus) {
            result.status = scheduleStatus
        }
    }

    return result
}

export function parseScheduleResponse(data: object): GetNotificationScheduleResponse {
    return plainToInstance(GetNotificationScheduleResponse, data, {
        excludeExtraneousValues: false,
    })
}

export function parseTestResponse(data: Record<string, unknown>): GetDomainNotificationABTestResponse {
    return plainToInstance(GetDomainNotificationABTestResponse, data, {
        excludeExtraneousValues: false,
    })
}

export function getAltNativeUrl(
    channels?: GetNotificationTemplateChannelsResponse
): string | undefined {
    const defaultChannel = channels?.default
    const nativeIos = channels?.native_ios
    const nativeAndroid = channels?.native_android

    if (!nativeIos && !nativeAndroid) return undefined

    const nativeLandingUrl = nativeAndroid?.landing_url ?? nativeIos?.landing_url
    if (nativeLandingUrl && nativeLandingUrl !== defaultChannel?.landing_url) {
        return nativeLandingUrl
    }

    return undefined
}
